import React from 'react';
import PropTypes from 'prop-types';
import './AutoCheckoutEducation.scss';

/**
 * The Auto Checkout Education
 */
export default function AutoCheckoutEducation(props) {
  const {
    hideHeader,
  } = props;

  return (
    <div className="auto-checkout-education-container">
      <section className="slide-content with-background">
        { !hideHeader && (
          <h1>Auto Checkout</h1>
        )}

        <h1 className="sub-header">What to expect:</h1>
        <p>
          <span className="icon-background">
            <span className="phone-action-clock-1-icon" />
          </span>
          <span>Clients are charged automatically one hour after the appointment.</span>
        </p>
        <p>
          <span className="icon-background">
            <span className="messages-bubble-square-text-icon" />
          </span>
          <span>
            Your client will get a text message or email that allows them to adjust the tip.
          </span>
        </p>
        <h1 className="sub-header"> Pro Tips </h1>
        <p>
          <span className="icon-background">
            <span className="cash-payment-bills-icon" />
          </span>
          <span>
            If there&apos;s no card on file, you can manually check out the appointment.
          </span>
        </p>
        <p>
          <span className="icon-background">
            <span className="receipt-dollar-icon" />
          </span>
          <span>
            You can update the total cost up to one hour after the appointment ends.
          </span>
        </p>
        <p>
          <span className="icon-background">
            <span className="calendar-exclamation-icon" />
          </span>
          <span>
            If there&apos;s a problem with the card on file, the appointment will show up red on your calendar.
          </span>
        </p>
      </section>
    </div>
  );
}

AutoCheckoutEducation.propTypes = {
  hideHeader: PropTypes.bool,
};

AutoCheckoutEducation.defaultProps = {
  hideHeader: false,
};
